import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Button } from 'components/common/Elements/Elements';
import BodyFilterDropdown from './BodyFilterDropdown/BodyFilterDropdown';

import classes from './FiltersListButtons.module.scss';

const FiltersListButtons = ({
  filterBackend,
  setChangeFilter,
  changeFilter,
  setFilter,
  onDellFilter,
  handleChangeFilter,
  onSaveFilter
}) => {
  return (
    <div className={cn(filterBackend.value.length > 1 && classes.wrapButton)}>
      {filterBackend.value.length > 1 &&
        filterBackend.value.map(
          (filter, index) =>
            index < 4 && (
              <Button
                key={filter.name}
                className={cn(
                  classes.button,
                  changeFilter === filter.name && classes.button_change
                )}
                onClick={() => handleChangeFilter(filter.name)}
              >
                {filter.name}
              </Button>
            )
        )}
      {filterBackend.value.length > 1 && (
        <BodyFilterDropdown
          filterBackend={filterBackend}
          changeFilter={changeFilter}
          setChangeFilter={setChangeFilter}
          setFilter={setFilter}
          onDellFilter={onDellFilter}
          onSaveFilter={onSaveFilter}
          handleChangeFilter={handleChangeFilter}
        />
      )}
    </div>
  );
};

FiltersListButtons.propTypes = {
  filterBackend: PropTypes.object,
  setChangeFilter: PropTypes.func.isRequired,
  changeFilter: PropTypes.string.isRequired,
  setFilter: PropTypes.func.isRequired,
  onDellFilter: PropTypes.func.isRequired,
  handleChangeFilter: PropTypes.func.isRequired,
  onSaveFilter: PropTypes.func.isRequired
};

export default FiltersListButtons;
